import { action, makeObservable, observable } from 'mobx';

import { getRandomNumber } from 'src/shared/utils/get-random-number';

import type { TGeologicalLoadData } from '../../geological-load-tab/types';

import type { GeoLoadSection } from './geo-load-section.entity';
import { GeologicalLoad } from './geological-load.entity';

export class GeoLoadStage {
  readonly entityId: number;
  readonly rigOperationEntityId: number;
  readonly stageEntityId: number;
  readonly geologicalLoad: GeologicalLoad;

  @observable sections: GeoLoadSection[] = [];

  constructor(rigOperationEntityId: number, stageEntityId: number, initialGeoLoad?: TGeologicalLoadData | null) {
    this.entityId = getRandomNumber(10);

    this.rigOperationEntityId = rigOperationEntityId;
    this.stageEntityId = stageEntityId;
    this.geologicalLoad = new GeologicalLoad(initialGeoLoad);

    makeObservable(this);
  }

  @action.bound
  setSections(sections: GeoLoadSection[]): void {
    this.sections = sections;
  }
}
